/* eslint-disable linebreak-style */
export const ADD_ROCKET = 'spaceTravels/rockets/ADD_ROCKET';

export const RESERVE_ROCKET = 'spaceTravels/rockets/RESERVE_ROCKET';
